import { ReactElement } from "react";

// material icons
import { Modal, IconButton } from "@mui/material";

// constants
import { PAY_CONTRACT } from "../constants";

// icons
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles.module.css";

interface Props {
  open: boolean;
  handleClose: () => void;
  children?: ReactElement;
}

const PaymentModal = ({ open, handleClose, children }: Props): JSX.Element => {
  return (
    <div dir="rtl">
      <Modal
        open={open}
        onClose={handleClose}
        className={styles.modalContainer}>
        <div className={styles.modalContent}>
          <div className={styles.header} dir="rtl">
            <p>{PAY_CONTRACT.TITLE}</p>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {children}
        </div>
      </Modal>
    </div>
  );
};

export default PaymentModal;
